<template>
  <figure
    v-if="$screen.isNotSmallOrUnknown"
    v-bind="$attrs"
    class="hidden relative md:block md:h-[9.125rem]"
  >
    <NuxtImg
      src="map/map-placeholder.svg"
      placeholder
      class="w-full h-full rounded-lg object-cover bg-[#e8eedb]"
    />
    <figcaption
      class="absolute bottom-4 md:bottom-auto md:top-1/2 md:-translate-y-1/2 flex justify-center w-full"
    >
      <WebccButton
        variant="theme"
        class="!text-base py-2.5 !px-10 md:py-[0.4375rem] md:!px-3"
        :disabled="disabled"
        @click="toggle(true)"
      >
        {{ $t(`${trPrefixMap}viewMap`) }}
      </WebccButton>
    </figcaption>
  </figure>

  <RedesignRoundButton
    v-if="$screen.isSmall"
    v-bind="$attrs"
    :disabled="disabled"
    class="flex md:hidden"
    @click="toggle(true)"
  >
    <WebccIcon name="searchpage/frame" class="h-4 w-4 mr-2" />
    {{ $t('www.components.views.search.area.map') }}
  </RedesignRoundButton>

  <RedesignWebccDialog full-screen :open="isOpen" @close="toggle(false)">
    <template #title>
      <RedesignFilterButton
        v-model="model"
        class="-my-2"
        @on-opened="handleOpenFilterMobile"
      />
    </template>

    <template #default>
      <RedesignMap
        :filters
        :viewport="searchResults.viewport"
        class="w-full h-full"
      />
    </template>
  </RedesignWebccDialog>
</template>

<script setup lang="ts">
const trPrefixMap = 'www.map.'

withDefaults(
  defineProps<{
    disabled?: boolean
  }>(),
  {
    disabled: false,
  },
)

const model = defineModel<SearchState>({ required: true })

const [isOpen, toggle] = useToggle()
const tracking = useTracking()

const searchResults = useSearchResults(toReactive(model))

const filters = computed(() => mapSearchStateToSearchApiParams(model.value))

watch(isOpen, (value) => value && tracking.handlers?.search.mapView())

function handleOpenFilterMobile() {
  tracking.handlers?.redesignFilters.filterMobile(true)
}
</script>
